import { render, staticRenderFns } from "./SharesOperationsOverview.vue?vue&type=template&id=2d044542&"
import script from "./SharesOperationsOverview.vue?vue&type=script&lang=js&"
export * from "./SharesOperationsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports